/**
 * DataGrid cell that renders one LinkChip.
 * Prefer `value` when id and name are the same (e.g. TABLE_TYPE); otherwise
 * pass `id` / `name` explicitly.
 */
import React from "react";
import { LinkChip, LinkChipType } from "components/LinkChip";
import { ChipCellContainer } from "./ChipCellContainer";

export type SingleChipCellProps = {
  readonly id?: string | null;
  readonly name?: string | null;
  readonly chipType: LinkChipType;
  /** Convenience when id and name are the same (e.g. TABLE_TYPE). */
  readonly value?: string | null;
};

export function SingleChipCell({
  id,
  name,
  chipType,
  value,
}: SingleChipCellProps) {
  const chipName = (name ?? value)?.trim();
  const chipId = (id ?? name ?? value)?.trim();

  if (!chipName || !chipId) {
    return <ChipCellContainer />;
  }

  return (
    <ChipCellContainer>
      <LinkChip id={chipId} name={chipName} chipType={chipType} />
    </ChipCellContainer>
  );
}
